import React from 'react';
import type {
  PvdConfigurationOnAzure,
  UpdatePvdConfigRequest,
} from '@/../generated-client/models';
import { PvdConfigModalBase } from './PvdConfigModalBase';

interface Props {
  show: boolean;
  onHide: () => void;
  config: PvdConfigurationOnAzure;
  onUpdate: (updated: UpdatePvdConfigRequest) => void;
}

export const EditPvdConfigModal: React.FC<Props> = ({ show, onHide, config, onUpdate }) => {
  return (
    <PvdConfigModalBase
      show={show}
      onHide={onHide}
      config={config}
      onSave={onUpdate}
      mode="edit"
    />
  );
};
